.actionLink {
  color: var(--text-primary);

  &:hover {
    text-decoration: underline;
    color: var(--text-primary);
  }
}
